import { create } from "zustand";

export type CompteId = "tous" | "orange_money" | "mtn" | "wave" | "banque" | "manuel";

const COMPTES: { id: CompteId; label: string }[] = [
  { id: "tous", label: "Tous les comptes" },
  { id: "banque", label: "Banque" },
  { id: "orange_money", label: "Orange Money" },
  { id: "mtn", label: "MTN MoMo" },
  { id: "wave", label: "Wave" },
  { id: "manuel", label: "Manuel" },
];

interface TransactionsHeaderState {
  balance: number;
  selectedCompteId: CompteId;
  setBalance: (b: number) => void;
  setSelectedCompteId: (id: CompteId) => void;
  comptes: typeof COMPTES;
}

export const useTransactionsHeaderStore = create<TransactionsHeaderState>((set) => ({
  balance: 0,
  selectedCompteId: "tous",
  setBalance: (balance) => set({ balance }),
  setSelectedCompteId: (selectedCompteId) => set({ selectedCompteId }),
  comptes: COMPTES,
}));
